module.exports = __webpack_public_path__ + "img/aop.b4fd2456.svg";